import { cn } from "@babybjorn/ui";
import {
	useEffect,
	useRef,
	useState,
	type FC,
	type PropsWithChildren,
} from "react";
import Button from "../../components/general/Button";
import * as s from "./Filter.module.scss";

type FilterProps = PropsWithChildren<{
	filterOnLabel: string;
}>;

const Filter: FC<FilterProps> = ({ filterOnLabel, children }) => {
	const listRef = useRef<HTMLDivElement>(null);
	const [isListOverflowing, setIsListOverflowing] = useState(false);
	const [showGradient, setShowGradient] = useState(true);

	const checkIfOverflowing = () => {
		const list = listRef.current;
		if (list && list.scrollWidth > list.clientWidth) {
			setIsListOverflowing(true);
		} else {
			setIsListOverflowing(false);
		}
	};

	useEffect(() => {
		checkIfOverflowing();
	}, []);

	const checkGradient = () => {
		const list = listRef.current;
		if (list && list.scrollLeft + list.offsetWidth === list.scrollWidth) {
			setShowGradient(false);
		} else {
			setShowGradient(true);
		}
	};

	useEffect(() => {
		window.addEventListener("resize", checkIfOverflowing);

		const currentListRef = listRef.current;

		currentListRef?.addEventListener("scroll", checkGradient);
		return () => {
			window.removeEventListener("resize", checkIfOverflowing);
			currentListRef?.removeEventListener("scroll", checkGradient);
		};
	}, []);

	const onRightScroll = () => {
		const list = listRef.current;

		list?.scrollBy({
			left: 100,
			behavior: "smooth",
		});
	};

	return (
		<div className={s.filter}>
			<label className={s.label}>{filterOnLabel}</label>
			<div className={s.listContainer}>
				<div ref={listRef} className={cn(s.filterList)}>
					{children}
				</div>
				{isListOverflowing && (
					<Button
						className={cn(s.scrollButton, { [s.gradient]: showGradient })}
						buttonType="icon"
						icon="arrow-right"
						variant="outlined"
						onClick={onRightScroll}
					/>
				)}
			</div>
		</div>
	);
};

export default Filter;
